import { useQueries, useQuery } from '@tanstack/react-query'
import { uniqueBy } from '../helpers/array'
import { ISocietiesModel } from '../interfaces/models/societies.interfaces'
import { unitQueries } from '../api/units'
import { IUserModel } from '../interfaces/models/users.interfaces'
import { userQueries } from '../api/users'

export const useUniqueNonAdminUsers = (
  society: ISocietiesModel | undefined
): IUserModel[] => {
  const { data: societyUnits } = useQuery(
    unitQueries.getUnitsPerSociety(society?._id)
  )
  const residents =
    societyUnits?.flatMap((unit) => unit.residentsList || []) || []

  const usersQuery = useQueries({
    queries: residents.map((resident) => userQueries.getUser(resident.userId)),
  })

  const residentUsers = usersQuery.flatMap((query) => query.data || [])

  const adminIds = society?.adminsList
    ? society.adminsList.map((admin) => admin.userId as string)
    : []

  const nonAdminUsers = residentUsers.filter(
    (user) => !adminIds.includes(user._id)
  )
  const uniqueNonAdminUsers = uniqueBy('_id', nonAdminUsers)

  return uniqueNonAdminUsers
}
